/**
 * creative web のエントリーポイント
 *
 * @graph-stack creative
 * @graph-domain Marketing
 * @graph-business creative web のエントリーポイント。Faro 初期化後に React アプリをマウントする。
 * @graph-connects none
 */
import { initializeFaro } from '@cortex/faro';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app.js';
import './styles.css';

initializeFaro({ appName: 'creative' });

/** React のマウント先要素。 */
/** @graph-connects none */
const rootElement = document.getElementById('root');

if (rootElement === null) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
